<template>
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0 13.2501C0 12.5597 0.559644 12 1.25 12L24.5833 12C25.2737 12 25.8333 12.5597 25.8333 13.2501C25.8333 13.9405 25.2737 14.5001 24.5833 14.5001L1.25 14.5001C0.559644 14.5001 0 13.9405 0 13.2501Z"
      fill="#2491E7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.2501 25.8333C12.5597 25.8333 12 25.2737 12 24.5833V1.24998C12 0.559623 12.5597 -2.15769e-05 13.2501 -2.15769e-05C13.9405 -2.15769e-05 14.5001 0.559623 14.5001 1.24998V24.5833C14.5001 25.2737 13.9405 25.8333 13.2501 25.8333Z"
      fill="#2491E7"
    />
  </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
